import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from '@/routes';
import { AuthProvider } from '@/context/AuthContext';
import { LocationProvider } from '@/context/LocationContext';
import { FlagsProvider } from '@/context/FlagsContext';   // r7.5 feature flags
import { ThemeProvider } from '@/themes/ThemeContext';
import { TenantProvider } from '@/context/TenantContext';   // r7.6 tenant shell (theme, brand, nav scope)
import { CategoryVars } from '@/components/discovery/CategoryVars';   // r7.6.4 --snt-cat-<slug> on <html>
import CookieConsent from '@/components/feature/CookieConsent';
import ReviewPrompt from '@/components/feature/ReviewPrompt';

import '@/locales/i18n';
import { initAnalytics } from '@/lib/analytics';
initAnalytics();
import { captureAttribution } from '@/lib/attribution';   // r7.7 (077): first-touch utm_* / fbclid / referrer, kept for the session, sent with the booking
captureAttribution(window.location);
import '@/styles/index.css';
import { registerServiceWorker } from './registerServiceWorker';
import { initDevice } from '@/lib/device';   // r7.4 device-bound QR — resolve the device id at boot
initDevice();
import { initNative, bindNavigator } from '@/lib/native';   // r7.6 step 9 — OTA, App Links, push, back button (native shell only)
bindNavigator((path) => router.navigate(path));
initNative();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <TenantProvider>
      <AuthProvider>
        <FlagsProvider>
        <LocationProvider>
          <CategoryVars />
          <RouterProvider router={router} />
          <CookieConsent />
          <ReviewPrompt />
        </LocationProvider>
        </FlagsProvider>
      </AuthProvider>
      </TenantProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// Register PWA service worker
registerServiceWorker();
